// Heuristic theme buckets for feedback rows. Both the server (writes
// the tag on insert, supports ?theme= filtering) and the admin UI
// (renders chips + tags) read from this list, so the two stay aligned.
// First match wins — order matters; more specific patterns must come
// before generic ones.

export type FeedbackTheme = string;

export const FEEDBACK_THEMES: { label: FeedbackTheme; re: RegExp }[] = [
  { label: "AI / Quick Add", re: /quick add|ai\b|wild radish|fig tree|identif|plant.?net|days until ripe|growing/i },
  { label: "Cart / Checkout", re: /\bcart\b|checkout|order summary|modify items|payment intent/i },
  { label: "Delivery / Driver", re: /delivery|driver|gps|pickup window|community delivery|deliver/i },
  { label: "Messages / Notifications", re: /message|chat|notification|push|inbox/i },
  { label: "Seller / Listings", re: /seller|listing|product|publish|inventory|stock|dashboard|fulfillment/i },
  { label: "Orders / Earnings", re: /\border|earning|refund|cancel/i },
  { label: "Rewards / Referral", re: /reward|referral|share|invite/i },
  { label: "Account / Profile", re: /account|profile/i },
  { label: "Onboarding / Mission", re: /onboarding|mission|tutorial|stuck on/i },
  { label: "Auth / Login", re: /login|sign in|password|oauth|google sign/i },
  { label: "Permissions / Native", re: /permission|location services|os\.permission/i },
  { label: "Cottage / Compliance", re: /cottage|compliance|fda|attestation/i },
  { label: "UX / Layout", re: /layout|design|button|link|page|nav|menu|hamburger/i },
];

export function themeForMessage(message: string | null | undefined): FeedbackTheme {
  const text = String(message ?? "");
  for (const { label, re } of FEEDBACK_THEMES) {
    if (re.test(text)) return label;
  }
  return "Other";
}

export function isKnownTheme(t: string | null | undefined): boolean {
  if (!t) return false;
  if (t === "Other") return true;
  return FEEDBACK_THEMES.some((entry) => entry.label === t);
}
